
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component({})
export default class PageMenuLayout extends Vue {
  @Prop() private title!: string
}
